(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/event-by-product-list-widget/assets/javascripts/event-by-product-list.js') >= 0) return;  svs.modules.push('/components/sport/event-by-product-list-widget/assets/javascripts/event-by-product-list.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _getAllServerImports = () => {
  const path = require('path');
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  const localRequire = file => require(path.join(__dirname, file));
  localRequire('handlebars-helpers.es6');
  return Object.freeze({
    prepareTTLCache: () => new trinidad.ttlcache(),
    getSportTypeConfig: localRequire('get-sport-type-config.es6'),
    queryDataAsync: localRequire('query-data-async.es6'),
    extractEventItems: localRequire('./extract-event-items.es6')
  });
};
const _getAllClientImports = svs => Object.freeze({
  prepareTTLCache: () => {},
  getSportTypeConfig: svs.components.sport.eventByProductListWidget.getSportTypeConfig,
  queryDataAsync: svs.components.sport.eventByProductListWidget.queryDataAsync,
  extractEventItems: svs.components.sport.eventByProductListWidget.extractEventItems
});
const _ref = svs.isServer ? _getAllServerImports() : _getAllClientImports(svs),
  prepareTTLCache = _ref.prepareTTLCache,
  getSportTypeConfig = _ref.getSportTypeConfig,
  queryDataAsync = _ref.queryDataAsync,
  extractEventItems = _ref.extractEventItems;
const ttlCache = prepareTTLCache();
const ONE_MINUTE = 60 * 1000;
const MAX_NUMBER_OF_MATCHES = 8;


async function getEventsByFilter(req, res, context) {
  const cmsConfig = context.config;
  const areaName = context.area;
  const title = cmsConfig.title;

  const sportTypeConfig = getSportTypeConfig(cmsConfig);
  const cacheKey = sportTypeConfig.cacheKey;
  let responses = ttlCache.get(cacheKey);
  if (!responses) {
    const _await$Promise$all = await Promise.all([queryDataAsync({
        target: 'draws',
        sportTypeConfig,
        req
      }), queryDataAsync({
        target: 'drawsJackpot',
        sportTypeConfig,
        req
      }), queryDataAsync({
        target: 'racing',
        sportTypeConfig,
        req
      })]),
      _await$Promise$all2 = _slicedToArray(_await$Promise$all, 3),
      draws = _await$Promise$all2[0],
      drawsJackpot = _await$Promise$all2[1],
      racing = _await$Promise$all2[2];
    const racingJackpot = await queryDataAsync({
      target: 'racingJackpot',
      sportTypeConfig,
      payload: {
        racingResponse: racing
      },
      req
    });
    responses = {
      draws,
      drawsJackpot,
      racing,
      racingJackpot
    };
    ttlCache.set(cacheKey, responses, 5 * ONE_MINUTE);
  }
  const drawEventItems = await extractEventItems({
    target: 'draws',
    response: responses.draws,
    req,
    jackpotsResponse: responses.drawsJackpot,
    cmsConfig,
    areaName
  });
  const racingEventItems = await extractEventItems({
    target: 'racing',
    response: responses.racing,
    req,
    jackpotsResponse: responses.racingJackpot,
    cmsConfig,
    areaName
  });
  const eventsByProduct = [...drawEventItems, ...racingEventItems];
  eventsByProduct.sort((a, b) => b.sortNetSale - a.sortNetSale);
  eventsByProduct.sort((a, b) => a.sortTS - b.sortTS);
  eventsByProduct.splice(MAX_NUMBER_OF_MATCHES);
  return {
    title,
    eventsByProduct
  };
}

if (svs.isServer) {
  module.exports = {
    getEventsByFilter
  };
} else {
  setGlobal('svs.components.sport.eventByProductListWidget', {
    getEventsByFilter
  });
}

 })(window);